import React from 'react';
import utils from '../../services/utils';
import CardBankPayout from '../CardBankPayout/CardBankPayout';
import FieldBold from '../Fields/FieldBold/FieldBold';

import classes from './AccountsOrigin.module.scss';

const AccountsOrigin = ({ sourceAccounts, isShowTotal = true, methodForPay }) => {
  return (
    <div className={classes.origin}>
      {sourceAccounts.length === 1 ? (
        <FieldBold title={methodForPay === 'PSEPay' ? 'MÉTODO DE PAGO' : methodForPay === 'cybersource' ? 'MÉTODO DE PAGO' : methodForPay === 'TC' ? 'MÉTODO DE PAGO' : 'CUENTA ORIGEN'}>
          <CardBankPayout
            name={sourceAccounts[0].name}
            methodForPay={methodForPay}
            isButton={false}
            bankId={sourceAccounts[0].bankId}
            subtypeLabel={sourceAccounts[0].subtypeLabel}
            identification={sourceAccounts[0].identification}
            bankLast4Digits={sourceAccounts[0].bankLast4Digits}
          />
        </FieldBold>
      ) : (
        sourceAccounts.map((account, idx) => (
          <FieldBold key={account.bankId} title={`CUENTA ORIGEN #${idx + 1}`}>
            {isShowTotal && (
              <span className={`${classes['total-origin']} medium-14`}>
                Total cuenta #{idx + 1}: {utils.moneyFormat(account.value)}
              </span>
            )}
            <CardBankPayout
              isButton={false}
              bankId={account.bankId}
              subtypeLabel={account.subtypeLabel}
              bankLast4Digits={account.bankLast4Digits}
            />
          </FieldBold>
        ))
      )}
    </div>
  );
};

export default AccountsOrigin;
